
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
import { ElMessage, ElMessageBox } from "element-plus";
import MiezzPageList from "@/models/MiezzPageList";
import MiezzModal, { MiezzModalType } from "@/models/MiezzModal";
import MiezzButton from "@/models/MiezzButton";
import OrderPoolContainerTrailerAppService from "@/apis.machine/OrderPoolContainerTrailerAppService";
import DtoPageListSearchOrderPoolContainerTrailer, { DtoPageListSearchOrderPoolContainerTrailerDynamicSearchItems } from "@/models.machine/DtoPageListSearchOrderPoolContainerTrailer";
import DtoPageListOrderPoolContainerTrailer from "@/models.machine/DtoPageListOrderPoolContainerTrailer";
import DtoListItemOrderPoolContainerTrailer, {
  DtoListItemOrderPoolContainerTrailerMiezzListItems,
} from "@/models.machine/DtoListItemOrderPoolContainerTrailer";
import UiSelectOption from "@/models.machine/UiSelectOption";
import ParamContainerTypeAppService from "@/apis.machine/ParamContainerTypeAppService";
import CurrentLogier from "@/apis/CurrentLogier";
import DtoSelectOptionParamCountryArea from "@/models.machine/DtoSelectOptionParamCountryArea";
import ParamCountryAreaAppService from "@/apis.machine/ParamCountryAreaAppService";
import DtoHistoryCompanyAddress_CompanyName from "@/models.machine/DtoHistoryCompanyAddress_CompanyName";
import DtoListItemOrderPoolContainerTrailer_OrderPoolContainerTrailerAddress from "@/models.machine/DtoListItemOrderPoolContainerTrailer_OrderPoolContainerTrailerAddress";
import DtoCallbackAMapPlaceTextPoi from "@/models.machine/DtoCallbackAMapPlaceTextPoi";
import DtoHistoryCompanyAddress_Contact from "@/models.machine/DtoHistoryCompanyAddress_Contact";
import moment from "moment";
import MiezzForm from "@/models/MiezzForm";
import DtoPutOrderPoolContainerTrailer_ArrivalTime, {
  DtoPutOrderPoolContainerTrailer_ArrivalTimeMiezzFormItems,
  DtoPutOrderPoolContainerTrailer_ArrivalTimeRules,
} from "@/models.machine/DtoPutOrderPoolContainerTrailer_ArrivalTime";
import DtoPutOrderPoolContainerTrailer_Addresses, {
  DtoPutOrderPoolContainerTrailer_AddressesMiezzFormItems,
} from "@/models.machine/DtoPutOrderPoolContainerTrailer_Addresses";
import DtoPutOrderPoolContainerTrailer_ContainerType, {
  DtoPutOrderPoolContainerTrailer_ContainerTypeMiezzFormItems,
  DtoPutOrderPoolContainerTrailer_ContainerTypeRules,
} from "@/models.machine/DtoPutOrderPoolContainerTrailer_ContainerType";
import { DtoPutOrderPoolContainerTrailer_Addresses_AddresseRules } from "@/models.machine/DtoPutOrderPoolContainerTrailer_Addresses_Addresse";
import { EnumCompanyType } from "@/models.machine/EnumCompanyType";
import DtoPutOrderPoolContainerTrailer_Executor, {
  DtoPutOrderPoolContainerTrailer_ExecutorMiezzFormItems,
  DtoPutOrderPoolContainerTrailer_ExecutorRules,
} from "@/models.machine/DtoPutOrderPoolContainerTrailer_Executor";
import DtoPutOrderPoolContainerTrailer_CarryContainerArea, {
  DtoPutOrderPoolContainerTrailer_CarryContainerAreaMiezzFormItems,
  DtoPutOrderPoolContainerTrailer_CarryContainerAreaRules,
} from "@/models.machine/DtoPutOrderPoolContainerTrailer_CarryContainerArea";
import DtoPutOrderPoolContainerTrailer_CarryContainerTime, {
  DtoPutOrderPoolContainerTrailer_CarryContainerTimeMiezzFormItems,
  DtoPutOrderPoolContainerTrailer_CarryContainerTimeRules,
} from "@/models.machine/DtoPutOrderPoolContainerTrailer_CarryContainerTime";
import DtoPutOrderPoolContainerTrailer_PlanCarryContainerTime, {
  DtoPutOrderPoolContainerTrailer_PlanCarryContainerTimeMiezzFormItems,
  DtoPutOrderPoolContainerTrailer_PlanCarryContainerTimeRules,
} from "@/models.machine/DtoPutOrderPoolContainerTrailer_PlanCarryContainerTime";
import DtoPutOrderPoolContainerTrailer_IntoPortWharf, {
  DtoPutOrderPoolContainerTrailer_IntoPortWharfMiezzFormItems,
  DtoPutOrderPoolContainerTrailer_IntoPortWharfRules,
} from "@/models.machine/DtoPutOrderPoolContainerTrailer_IntoPortWharf";
import DtoPutOrderPoolContainerTrailer_BackContainerTime, {
  DtoPutOrderPoolContainerTrailer_BackContainerTimeMiezzFormItems,
  DtoPutOrderPoolContainerTrailer_BackContainerTimeRules,
} from "@/models.machine/DtoPutOrderPoolContainerTrailer_BackContainerTime";
import DtoPutOrderPoolContainerTrailer_ContainerNo, {
  DtoPutOrderPoolContainerTrailer_ContainerNoMiezzFormItems,
} from "@/models.machine/DtoPutOrderPoolContainerTrailer_ContainerNo";
import DtoPutOrderPoolContainerTrailer_SealNo, {
  DtoPutOrderPoolContainerTrailer_SealNoMiezzFormItems,
  DtoPutOrderPoolContainerTrailer_SealNoRules,
} from "@/models.machine/DtoPutOrderPoolContainerTrailer_SealNo";
import DtoPutOrderPoolContainerTrailer_File, {
  DtoPutOrderPoolContainerTrailer_FileMiezzFormItems,
  DtoPutOrderPoolContainerTrailer_FileRules,
} from "@/models.machine/DtoPutOrderPoolContainerTrailer_File";
import { MiezzMenuTab } from "@/components/MiezzMenuTab.vue";
import { EnumOrderServiceType } from "@/models.machine/EnumOrderServiceType";
import CompanyAddressAppService from "@/apis.machine/CompanyAddressAppService";
import DtoHistory from "@/models.machine/DtoHistory";
import Logier from "@/models.machine/Logier";
import { EnumOrderStatus } from "@/models.machine/EnumOrderStatus";
import { EnumOrderPoolStatus } from "@/models.machine/EnumOrderPoolStatus";
import { isArray } from "element-plus/es/utils";
import OrderSummaryTime from "../../OrderSummaryTime.vue";
import OrderSupplier from "../../OrderSupplier.vue";
import OrderAppService from "@/apis.machine/OrderAppService";
import OrderMainBillAppService from "@/apis.machine/OrderMainBillAppService";
import DtoListItemOrderPoolContainerTrailer_StopAddress from "@/models.machine/DtoListItemOrderPoolContainerTrailer_StopAddress";
import DtoPutOrderPoolContainerTrailer_StopAddress, {
  DtoPutOrderPoolContainerTrailer_StopAddressMiezzFormItems,
  DtoPutOrderPoolContainerTrailer_StopAddressRules,
} from "@/models.machine/DtoPutOrderPoolContainerTrailer_StopAddress";
import { EnumOrderPoolContainerTrailerStopAddressTimeType } from "@/models.machine/EnumOrderPoolContainerTrailerStopAddressTimeType";
import UiSelectOptionWithStringValue from "@/models.machine/UiSelectOptionWithStringValue";
import ListMarkColorAppService from "@/apis.machine/ListMarkColorAppService";
import DynamicSearchAppService from "@/apis.machine/DynamicSearchAppService";
import { EnumRelation } from "@/models.machine/EnumRelation";
import { EnumCompare } from "@/models.machine/EnumCompare";

@Options({
  components: {
    OrderSummaryTime,
    OrderSupplier,
  },
})
export default class ContainerTrailerPageList extends Vue {
  @Prop() menuTab?: MiezzMenuTab;
  /**分页列表 */
  @Prop() list!: MiezzPageList<
    DtoPageListSearchOrderPoolContainerTrailer,
    DtoListItemOrderPoolContainerTrailer,
    string
  >;
  @Prop() serviceType!: EnumOrderServiceType;
  @Prop() addPower = "";
  @Prop() editPower = "";
  @Prop() deletePower = "";
  @Prop() orderId?: string;
  @Prop() poolId?: string;
  @Prop() disabledHistories?: boolean;
  @Prop() pageSize?: number;

  colors: UiSelectOptionWithStringValue[] = [];
  logier?: Logier;
  EnumCompanyType = EnumCompanyType;
  /**当前Id */
  id?: string;
  EnumOrderServiceType = EnumOrderServiceType;
  powers: string[] = [];
  btnAdd = new MiezzButton();
  histories: DtoHistory[] = [];
  canAdd = false;
  canEdit = false;

  addDeparturePortContainer = false;
  feedbackDeparturePortContainer = false;
  addDestinationPortContainer = false;
  feedbackDestinationPortContainer = false;

  btnBatchEdit: MiezzButton = {
    Code: "batch-edit",
    Icon: "edit",
    Type: "text",
    Size: "small"
  }

  threeApiProps: string[] = [
    "PlanCarryContainerTime",
    "CarryContainerTime",
    "CarryContainerAreaLabel",
    "IntoPortWharfLabel",
    "BackContainerTime",
  ]
  batchEditProps: string[] = [
    "CarryPlanTime",
    "Addresses",
    "ArrivalTime",
    "SupplierLabel",
    "CarryContainerAreaLabel",
    "PlanCarryContainerTime",
    "CarryContainerTime",
    "StopAddress",
    "IntoPortWharfLabel",
    "BackContainerTime",
    "CarryPlanTime",
  ]

  /**创建时 */
  created(): void {
    OrderPoolContainerTrailerAppService.GetColors({ ServiceType: this.serviceType }).then((r) => {
      this.colors = r.data.Data ?? [];
    });
    this.list.BottomButtons.splice(0, 0, {
      Code: "mark",
      Label: "标记",
      Type: "color",
      Size: "small",
    });
    this.addDeparturePortContainer =
      this.$route.query.task == "AddDeparturePortContainer";
    this.feedbackDeparturePortContainer =
      this.$route.query.task == "FeedbackDeparturePortContainer";
    this.addDestinationPortContainer =
      this.$route.query.task == "AddDestinationPortContainer";
    this.feedbackDestinationPortContainer =
      this.$route.query.task == "FeedbackDestinationPortContainer";

    this.logier = CurrentLogier.GetLogier();

    if (this.pageSize) {
      this.list.Fix = false;
      this.list.HideCard = true;
      this.list.EnabledSelect = false;
      this.list.EnabledPagination = false;
      this.list.EnabledDynamicSearch = false;
      this.list.EnabledRadioSearch = false;
    }
    else {
      this.list.DynamicSearchItems = DtoPageListSearchOrderPoolContainerTrailerDynamicSearchItems
      for (const item of this.list.DynamicSearchItems ?? []) {
        switch (item.Prop) {
          case "DynamicSearch_CarryPlanTime":
            item.Label =
              this.serviceType == EnumOrderServiceType.DeparturePort
                ? "计划装柜时间"
                : "计划拆柜时间";
            break;
          case "DynamicSearch_Address":
            item.Label =
              this.serviceType == EnumOrderServiceType.DeparturePort
                ? "装柜地址"
                : "拆柜地址";
            break;
          case "DynamicSearch_ArrivalTime":
            item.Label =
              this.serviceType == EnumOrderServiceType.DeparturePort
                ? "实际装柜时间"
                : "实际拆柜时间";
            break;
          case "DynamicSearch_BackContainerTime":
            item.Label =
              this.serviceType == EnumOrderServiceType.DeparturePort
                ? "进港时间"
                : "还柜时间";
            break;
          case "DynamicSearch_IntoPortWharfLabel":
            item.Label =
              this.serviceType == EnumOrderServiceType.DeparturePort
                ? "进港码头"
                : "还柜地点";
            break;

          default:
            break;
        }
      }
    }
    //列表-传参
    this.list.Dto = new DtoPageListSearchOrderPoolContainerTrailer();
    if (this.pageSize) {
      this.list.Dto.PageSize = this.pageSize;
    }
    //列表-数据-初始
    this.list.Data = new DtoPageListOrderPoolContainerTrailer();
    this.list.RowButtons = [
      {
        Code: "delete",
        Title: "删除",
        Icon: "delete",
        Type: "default",
        Size: "small",
        Message: "是否确认删除",
        PowerCode: this.deletePower,
      },
    ];
    this.list.CheckRowButtonShow = (btn, row) => {
      return (
        row.Order?.StowageOrder != true &&
        this.powers.contains(this.deletePower)
      );
    };
    //列表-列配置
    this.list.Items = JSON.copy(
      DtoListItemOrderPoolContainerTrailerMiezzListItems
    );
    if (this.pageSize) {
      this.list.Items = this.list.Items?.filter((it) => it.Prop != "OrderCode");
      console.log(this.list.Items);
    }
    for (const item of this.list.Items ?? []) {
      switch (item.Prop) {
        case "CarryPlanTime":
          item.Label =
            this.serviceType == EnumOrderServiceType.DeparturePort
              ? "计划装柜时间"
              : "计划拆柜时间";
          break;
        case "Addresses":
          item.Label =
            this.serviceType == EnumOrderServiceType.DeparturePort
              ? "装柜地址"
              : "拆柜地址";
          break;
        case "ArrivalTime":
          item.Label =
            this.serviceType == EnumOrderServiceType.DeparturePort
              ? "实际装柜时间"
              : "实际拆柜时间";
          break;
        case "BackContainerTime":
          item.Label =
            this.serviceType == EnumOrderServiceType.DeparturePort
              ? "进港时间"
              : "还柜时间";
          break;
        case "CarryContainerAreaLabel":
          item.Label =
            this.serviceType == EnumOrderServiceType.DeparturePort
              ? "提柜地点"
              : "提柜码头";
          break;
        case "IntoPortWharfLabel":
          item.Label =
            this.serviceType == EnumOrderServiceType.DeparturePort
              ? "进港码头"
              : "还柜地点";
          break;

        default:
          break;
      }
    }
    if (this.logier?.CompanyType == EnumCompanyType.ServiceProvider) {
      this.list.CellClassName = (data: any) => {
        const row = data.row as DtoListItemOrderPoolContainerTrailer;
        const add =
          this.addDeparturePortContainer || this.addDestinationPortContainer;
        const feedback =
          this.feedbackDeparturePortContainer ||
          this.feedbackDestinationPortContainer;
        switch (data.column.label) {
          case "箱型":
            if (add && !row.ContainerTypeId) {
              return "red";
            }
            break;
          case "装柜地址":
          case "拆柜地址":
            if (
              add &&
              !row.Addresses?.any(
                (it) => it.PlanTime && it.CompanyAddress?.Address
              )
            ) {
              return "red";
            }
            break;
          case "供应商":
            if (add && !row.SupplierCompanyId) {
              return "red";
            }
            break;
          // case "提柜时间":
          //   if (feedback && !row.CarryContainerTime) {
          //     return "red";
          //   }
          //   break;
          case "箱号":
            if (feedback && !row.ContainerNo) {
              return "red";
            }
            break;
          case "封号":
            if (feedback && !row.SealNo) {
              return "red";
            }
            break;
          case "实际装柜时间":
          case "实际拆柜时间":
            if (feedback && !row.ArrivalTime) {
              return "red";
            }
            break;

          default:
            break;
        }

        return "";
      };
    }

    this.btnAdd = {
      Code: "add",
      Label: "添加",
      Icon: "plus",
      Type: "text",
      // Size: "small",
      PowerCode: this.addPower,
    };

    if (!this.pageSize) {
      OrderPoolContainerTrailerAppService.GetClientSelectByServiceType(
        this.serviceType
      ).then((r) => {
        this.clients = r.data.Data ?? [];
      });
    }
  }

  /**格式化时间 */
  formatTime(v?: Date): string {
    return v ? moment(v).format("YYYY-MM-DD HH:mm") : "暂无数据";
  }
  /**格式化枚举 */
  formatEnum(options: UiSelectOption<number>[], value?: number): string {
    return (
      options.firstOrDefault((it) => it.Value == value)?.Label ?? "暂无数据"
    );
  }

  /**查询列表 */
  handleGet(): void {
    const dto = JSON.copy(this.list.Dto);
    dto.PoolId = this.poolId;
    dto.OrderId = this.orderId;
    dto.ServiceType = this.serviceType;
    if (this.pageSize) {
      dto.PageSize = this.pageSize;
    }
    CurrentLogier.GetPowerCodes().then((powers) => {
      this.powers = powers ?? [];
      OrderPoolContainerTrailerAppService.Get(dto).then((r) => {
        this.list.Data = r.data.Data;
        this.canAdd =
          this.powers.contains(this.addPower) &&
          (this.pageSize
            ? this.list.Data?.Items?.firstOrDefault()?.Order?.StowageOrder !=
            true
            : true);
        this.canEdit = this.powers.contains(this.editPower);
        this.list.Items?.filter((it) => this.threeApiProps.contains(it.Prop) || this.batchEditProps.contains(it.Prop)).map((it) => {
          it.CustomizeHeader = true;
          return it;
        });

        this.initContainerType();
        this.initAddresses();
        this.initArrivalTime();
        this.initExecutor();
        this.initCarryContainerArea();
        this.initPlanCarryContainerTime();
        this.initCarryContainerTime();
        this.initStopAddress();
        this.initIntoPortWharf();
        this.initBackContainerTime();
        this.initContainerNo();
        this.initSealNo();
        this.initFile();
        if (!this.pageSize) {
          this.initAdd();
        }
      });
    });
    if (!this.disabledHistories) {
      OrderPoolContainerTrailerAppService.GetHistories(dto).then((r) => {
        this.histories = r.data.Data ?? [];
      });
    }
  }

  clients: UiSelectOption<string>[] = [];
  bookingNos: UiSelectOption<string>[] = [];
  modalAdd = new MiezzModal(MiezzModalType.Dialog);
  formAdd = new MiezzForm<
    {
      ClientCompanyId?: string;
      PoolId?: string;
    },
    string
  >();
  initAdd(): void {
    this.modalAdd.Title = "添加";
    this.modalAdd.Buttons = [
      {
        Code: "save-add",
        Label: "保存",
        Type: "primary",
        Size: "small",
      },
    ];
    this.modalAdd.HandleClick = this.handleTopButtonClick;
    this.formAdd.Data = {};
    this.formAdd.Rules = {
      ClientCompanyId: [
        {
          required: true,
          message: "信息不能为空",
          trigger: "change",
        },
      ],
      PoolId: [
        {
          required: true,
          message: "信息不能为空",
          trigger: "change",
        },
      ],
    };
  }
  @Watch("formAdd.Data.ClientCompanyId")
  onFormAddClientCompanyIdChanged(): void {
    if (this.formAdd.Data.ClientCompanyId) {
      OrderPoolContainerTrailerAppService.GetBookingNoSelectByServiceType(
        this.serviceType,
        this.formAdd.Data.ClientCompanyId
      ).then((r) => {
        this.bookingNos = r.data.Data ?? [];
        if (this.bookingNos.length == 1) {
          this.formAdd.Data.PoolId = this.bookingNos.firstOrDefault()?.Value;
        }
      });
    } else {
      this.formAdd.Data.PoolId = undefined;
      this.bookingNos = [];
    }
  }

  /**箱型-选择器数据 */
  containerTypes: UiSelectOption<string>[] = [];
  /**箱型-模态框 */
  modalContainerType = new MiezzModal(MiezzModalType.Dialog);
  /**箱型-表单 */
  formContainerType = new MiezzForm<
    DtoPutOrderPoolContainerTrailer_ContainerType,
    string
  >();
  /**箱型-初始化 */
  initContainerType(): void {
    // 获取箱型选择器
    if (this.canEdit) {
      this.modalContainerType.Title = "编辑箱型";
      ParamContainerTypeAppService.GetSelect().then((r) => {
        this.containerTypes = r.data.Data ?? [];
      });
      this.modalContainerType.Buttons = [
        {
          Code: "save-container-type",
          Label: "保存",
          Type: "primary",
          Size: "small",
        },
      ];
    } else {
      this.modalContainerType.Title = "查看箱型";
    }

    // 模态框-箱型
    this.modalContainerType.Height = "100px";
    this.modalContainerType.HandleClick = this.handleTopButtonClick;
    this.formContainerType.Items =
      DtoPutOrderPoolContainerTrailer_ContainerTypeMiezzFormItems;
    this.formContainerType.Rules =
      DtoPutOrderPoolContainerTrailer_ContainerTypeRules;
  }

  /**提货地址与时间-抽屉 */
  modalCarryPlanTime = new MiezzModal(MiezzModalType.Dialog);
  formCarryPlanTime = new MiezzForm<
    DtoPutOrderPoolContainerTrailer_Addresses,
    string
  >();

  /**提货地址与时间-抽屉 */
  modalAddresses = new MiezzModal(MiezzModalType.Drawer);
  /**提货地址与时间-表单 */
  formAddresses = new MiezzForm<
    DtoPutOrderPoolContainerTrailer_Addresses,
    string
  >();
  /**提货地址与时间-添加按钮 */
  btnAddAddress: MiezzButton = {
    Code: "add-address",
    Label: "添加",
    Icon: "plus",
    Type: "primary",
    Size: "small",
  };
  /**提货地址与时间-删除按钮 */
  btnDeleteAddress: MiezzButton = {
    Code: "delete-address",
    Title: "删除",
    Icon: "delete",
    Type: "text",
    Size: "small",
  };
  /**提货地址与时间-初始化 */
  initAddresses(): void {
    const label =
      this.serviceType == EnumOrderServiceType.DeparturePort
        ? "装柜地址"
        : "拆柜地址";
    const timeLabel =
      this.serviceType == EnumOrderServiceType.DeparturePort
        ? "计划装柜时间"
        : "计划拆柜时间";
    this.modalCarryPlanTime.Height = "100px";
    if (this.canEdit) {
      this.modalAddresses.Title = "编辑" + label;
      this.modalCarryPlanTime.Title = "编辑" + timeLabel;
      this.modalAddresses.Buttons = [
        {
          Code: "save-addresses",
          Label: "保存",
          Type: "primary",
          Size: "small",
        },
      ];
      this.modalCarryPlanTime.Buttons = [
        {
          Code: "save-carry-plan-time",
          Label: "保存",
          Type: "primary",
          Size: "small",
        },
      ];
    } else {
      this.modalAddresses.Title = "查看" + label;
      this.modalCarryPlanTime.Title = "查看" + timeLabel;
    }
    this.modalAddresses.HandleClick = this.handleTopButtonClick;
    this.modalCarryPlanTime.HandleClick = this.handleTopButtonClick;
    this.formAddresses.Items =
      DtoPutOrderPoolContainerTrailer_AddressesMiezzFormItems;
    this.formAddresses.Rules =
      DtoPutOrderPoolContainerTrailer_Addresses_AddresseRules;
    this.formAddresses.Rules.Address = [
      {
        required: true,
        message: "信息不能为空",
        trigger: "change",
      },
    ];

    this.formCarryPlanTime.Items = [
      {
        Prop: "CarryPlanTime",
        Label: timeLabel,
        Customize: true,
      },
    ];
    this.formCarryPlanTime.Rules = {
      CarryPlanTime: [
        {
          required: true,
          message: "信息不能为空",
          trigger: "change",
        },
      ],
    };
  }

  /**提货地址与时间-删除 */
  handleDeleteAddress(i: number, complete: () => void): void {
    this.formAddresses.Data.Addresses?.splice(i, 1);
    complete();
  }

  /**提货地址与时间-获取公司名称 */
  getConpanyNames(q: string, cb: any): void {
    CompanyAddressAppService.GetCompanyNames(q).then((r) => {
      cb(r.data.Data ?? []);
    });
  }
  /**提货地址与时间-选择公司名称 */
  handleSelectCompanyName(
    select: DtoHistoryCompanyAddress_CompanyName,
    item: DtoListItemOrderPoolContainerTrailer_OrderPoolContainerTrailerAddress
  ): void {
    if (item.CompanyAddress) {
      if (select.AreaLabel) {
        item.CompanyAddress.AreaLabel = select.AreaLabel;
      } else if (select.AreaCode) {
        CompanyAddressAppService.GetAreaByCode(
          select.AreaCode,
          select.AreaLongitude,
          select.AreaLatitude
        ).then((r) => {
          if (item.CompanyAddress) {
            item.CompanyAddress.AreaLabel = r.data.Data?.FullName;
            if (!item.CompanyAddress.Address && r.data.Data?.DetailedAddress)
              item.CompanyAddress.Address = r.data.Data?.DetailedAddress;
          }
        });
      }
      item.CompanyAddress.Address = select.Address;
      item.CompanyAddress.Contact = select.Contact;
      item.CompanyAddress.ContactNumber = select.ContactNumber;
    }
  }
  /**提货地址与时间-获取坐标 */
  getAreas(q: string, cb: any): void {
    if (q && q.length >= 2) {
      ParamCountryAreaAppService.GetSelect({
        Keywords: q,
      }).then((r) => {
        cb(r.data.Data ?? []);
      });
    } else {
      cb([]);
    }
  }
  /**提货地址与时间-选择坐标 */
  handleSelectArea(
    select: DtoSelectOptionParamCountryArea,
    item: DtoListItemOrderPoolContainerTrailer_OrderPoolContainerTrailerAddress
  ): void {
    if (item.CompanyAddress) {
      item.CompanyAddress.Address = select?.DetailedAddress;
    }
  }
  /**提货地址与时间-获取详细地址 */
  getAddresses(q: string, cb: any): void {
    if (q && q.length >= 2) {
      ParamCountryAreaAppService.GetAMapPlaceTextPoiByKeywords({
        Keywords: q,
        Offset: 5,
      }).then((r) => {
        cb(r.data.Data ?? []);
      });
    } else {
      cb([]);
    }
  }
  /**提货地址与时间-选择详细地址 */
  handleSelectAddresses(
    select: DtoCallbackAMapPlaceTextPoi,
    item: DtoListItemOrderPoolContainerTrailer_OrderPoolContainerTrailerAddress
  ): void {
    if (select.adcode) {
      CompanyAddressAppService.GetAreaByCode(
        select.adcode,
        select.Longitude,
        select.Latitude
      ).then((r) => {
        if (item.CompanyAddress) {
          item.CompanyAddress.AreaLabel = r.data.Data?.FullName;
        }
      });
    }
  }
  /**提货地址与时间-获取联系人 */
  getContacts(
    q: string,
    item: DtoListItemOrderPoolContainerTrailer_OrderPoolContainerTrailerAddress,
    cb: any
  ): void {
    CompanyAddressAppService.GetContacts({
      CompanyName: item.CompanyAddress?.CompanyName,
    }).then((r) => {
      const contacts = r.data.Data ?? [];
      item.Contacts = contacts;
      cb(
        contacts.filter((it) =>
          it.Contact?.toUpperCase()?.contains(q.toUpperCase())
        )
      );
    });
  }
  /**提货地址与时间-选择联系人 */
  handleSelectContact(
    select: DtoHistoryCompanyAddress_Contact,
    item: DtoListItemOrderPoolContainerTrailer_OrderPoolContainerTrailerAddress
  ): void {
    if (item.CompanyAddress) {
      item.CompanyAddress.ContactNumber = select.ContactNumber;
    }
  }

  handleDeleteContact(
    select: DtoHistoryCompanyAddress_Contact,
    value: string,
    item: DtoListItemOrderPoolContainerTrailer_OrderPoolContainerTrailerAddress
  ): void {
    CompanyAddressAppService.DeleteContactById(select.Id).then(() => {
      if (item.CompanyAddress) {
        const old = (
          item.Contacts as DtoHistoryCompanyAddress_Contact[]
        ).firstOrDefault((it) => it.Contact == value);
        if (old?.Contact == select.Contact) {
          item.CompanyAddress.Contact = undefined;
          item.CompanyAddress.ContactNumber = undefined;
        } else {
          item.CompanyAddress.Contact = old?.Contact;
          item.CompanyAddress.ContactNumber = old?.ContactNumber;
        }
      }
      ElMessage.success("历史记录已删除");
      return;
    });
  }

  /**实际装柜时间/实际拆柜时间-模态框 */
  modalArrivalTime = new MiezzModal(MiezzModalType.Dialog);
  /**实际装柜时间/实际拆柜时间-表单 */
  formArrivalTime = new MiezzForm<
    DtoPutOrderPoolContainerTrailer_ArrivalTime,
    string
  >();
  /**实际装柜时间/实际拆柜时间-初始化 */
  initArrivalTime(): void {
    const label =
      this.serviceType == EnumOrderServiceType.DeparturePort
        ? "实际装柜时间"
        : "实际拆柜时间";
    this.modalArrivalTime.Height = "100px";
    if (this.canEdit) {
      this.modalArrivalTime.Title = "编辑" + label;
      this.modalArrivalTime.Buttons = [
        {
          Code: "save-arrival-time",
          Label: "保存",
          Type: "primary",
          Size: "small",
        },
      ];
    } else {
      this.modalArrivalTime.Title = "查看" + label;
    }
    this.modalArrivalTime.HandleClick = this.handleTopButtonClick;
    this.formArrivalTime.Items =
      DtoPutOrderPoolContainerTrailer_ArrivalTimeMiezzFormItems;
    this.formArrivalTime.Rules =
      DtoPutOrderPoolContainerTrailer_ArrivalTimeRules;
  }

  handleChangeStopAddressArrivalTime(
    item: DtoPutOrderPoolContainerTrailer_StopAddress
  ): void {
    if (
      item.LeaveTime &&
      item.ArrivalTime &&
      moment(item.LeaveTime) <= moment(item.ArrivalTime)
    ) {
      ElMessage.warning("驶离时间不能早于抵达时间");
      item.ArrivalTime = undefined;
    }
  }

  handleChangeArrivalTime(): void {
    const item = this.list.Data?.Items?.firstOrDefault(
      (it) => it.Id == this.id
    );
    if (
      item &&
      this.formArrivalTime.Data.LeaveTime &&
      this.formArrivalTime.Data.ArrivalTime &&
      moment(this.formArrivalTime.Data.LeaveTime) <=
      moment(this.formArrivalTime.Data.ArrivalTime)
    ) {
      ElMessage.warning("驶离时间不能早于抵达时间");
      this.formArrivalTime.Data.ArrivalTime = undefined;
    }
    if (
      item &&
      this.formArrivalTime.Data.ArrivalTime &&
      item.CarryContainerTime &&
      moment(this.formArrivalTime.Data.ArrivalTime) <=
      moment(item.CarryContainerTime)
    ) {
      if (this.serviceType == EnumOrderServiceType.DeparturePort) {
        ElMessage.warning(
          "时间应遵循如下规则：【实际提柜时间】早于【实际装柜时间】早于【进港时间】"
        );
      } else {
        ElMessage.warning(
          "时间应遵循如下规则：【实际提柜时间】早于【实际拆柜时间】早于【还柜时间】"
        );
      }
      this.formArrivalTime.Data.ArrivalTime = undefined;
    }
    if (
      item &&
      this.formArrivalTime.Data.ArrivalTime &&
      item.BackContainerTime &&
      moment(this.formArrivalTime.Data.ArrivalTime) >=
      moment(item.BackContainerTime)
    ) {
      if (this.serviceType == EnumOrderServiceType.DeparturePort) {
        ElMessage.warning(
          "时间应遵循如下规则：【实际提柜时间】早于【实际装柜时间】早于【进港时间】"
        );
      } else {
        ElMessage.warning(
          "时间应遵循如下规则：【实际提柜时间】早于【实际拆柜时间】早于【还柜时间】"
        );
      }
      this.formArrivalTime.Data.ArrivalTime = undefined;
    }
  }

  handleChangeStopAddressLeaveTime(
    item: DtoPutOrderPoolContainerTrailer_StopAddress
  ): void {
    console.log(item);
    if (
      item.LeaveTime &&
      item.ArrivalTime &&
      moment(item.LeaveTime) <= moment(item.ArrivalTime)
    ) {
      ElMessage.warning("驶离时间不能早于抵达时间");
      item.LeaveTime = undefined;
    }
  }

  handleChangeLeaveTime(): void {
    const item = this.list.Data?.Items?.firstOrDefault(
      (it) => it.Id == this.id
    );
    if (
      item &&
      this.formArrivalTime.Data.LeaveTime &&
      this.formArrivalTime.Data.ArrivalTime &&
      moment(this.formArrivalTime.Data.LeaveTime) <=
      moment(this.formArrivalTime.Data.ArrivalTime)
    ) {
      ElMessage.warning("驶离时间不能早于抵达时间");
      this.formArrivalTime.Data.LeaveTime = undefined;
    }
  }

  showSupplier = false;
  async handleSaveSupplier(data: any, complete: (s: boolean) => void): Promise<void> {
    if (data.Id) {
      OrderPoolContainerTrailerAppService.PutSupplier(data)
        .then(() => {
          this.handleGet();
          complete(true);
        })
        .catch(() => complete(false));
    } else {
      for (const id of this.list.SelectIds) {
        await OrderPoolContainerTrailerAppService.PutSupplier({
          ...data,
          Id: id
        })
      }
      this.handleGet();
      complete(true);
    }
  }

  btnAddExecutor: MiezzButton = {
    Code: "add-executor",
    Label: "添加",
    Icon: "plus",
    Type: "primary",
    Size: "small",
  };
  btnDeleteExecutor: MiezzButton = {
    Code: "delete-executor",
    Title: "删除",
    Icon: "delete",
    Type: "text",
    Size: "small",
  };
  /**执行人-模态框 */
  modalExecutor = new MiezzModal(MiezzModalType.Dialog);
  /**执行人-表单 */
  formExecutor = new MiezzForm<
    DtoPutOrderPoolContainerTrailer_Executor,
    string
  >();
  /**执行人-初始化 */
  initExecutor(): void {
    this.modalExecutor.Width = "800px";
    this.modalExecutor.Height = "400px";
    if (this.editPower) {
      this.modalExecutor.Title = "编辑执行人";
      this.modalExecutor.Buttons = [
        {
          Code: "save-executor",
          Label: "保存",
          Type: "primary",
          Size: "small",
        },
      ];
    } else {
      this.modalExecutor.Title = "查看执行人";
    }
    this.modalExecutor.HandleClick = this.handleTopButtonClick;
    this.formExecutor.Items =
      DtoPutOrderPoolContainerTrailer_ExecutorMiezzFormItems;
    this.formExecutor.Rules = DtoPutOrderPoolContainerTrailer_ExecutorRules;
  }

  handleDeleteExecutor(i: number, complete: () => void): void {
    this.formExecutor.Data.Executors?.splice(i, 1);
    complete();
  }

  /**提柜地点-模态框 */
  modalCarryContainerArea = new MiezzModal(MiezzModalType.Dialog);
  /**提柜地点-表单 */
  formCarryContainerArea = new MiezzForm<
    DtoPutOrderPoolContainerTrailer_CarryContainerArea,
    string
  >();
  /**提柜地点-初始化 */
  initCarryContainerArea(): void {
    const label =
      this.serviceType == EnumOrderServiceType.DeparturePort
        ? "提柜地点"
        : "提柜码头";
    this.modalCarryContainerArea.Height = "100px";
    if (this.editPower) {
      this.modalCarryContainerArea.Title = "编辑" + label;
      this.modalCarryContainerArea.Buttons = [
        {
          Code: "save-carry-container-area",
          Label: "保存",
          Type: "primary",
          Size: "small",
        },
      ];
    } else {
      this.modalCarryContainerArea.Title = "查看" + label;
    }
    this.modalCarryContainerArea.HandleClick = this.handleTopButtonClick;
    const items =
      DtoPutOrderPoolContainerTrailer_CarryContainerAreaMiezzFormItems;
    for (const item of items) {
      switch (item.Prop) {
        case "CarryContainerAreaLabel":
          item.Label =
            this.serviceType == EnumOrderServiceType.DeparturePort
              ? "提柜地点"
              : "提柜码头";
          break;

        default:
          break;
      }
    }
    this.formCarryContainerArea.Items = items;
    this.formCarryContainerArea.Rules =
      DtoPutOrderPoolContainerTrailer_CarryContainerAreaRules;
  }

  /**计划提柜时间-模态框 */
  modalPlanCarryContainerTime = new MiezzModal(MiezzModalType.Dialog);
  /**计划提柜时间-表单 */
  formPlanCarryContainerTime = new MiezzForm<
    DtoPutOrderPoolContainerTrailer_PlanCarryContainerTime,
    string
  >();
  /**计划提柜时间-初始化 */
  initPlanCarryContainerTime(): void {
    this.modalPlanCarryContainerTime.Height = "100px";
    if (this.editPower) {
      this.modalPlanCarryContainerTime.Title = "编辑计划提柜时间";
      this.modalPlanCarryContainerTime.Buttons = [
        {
          Code: "save-plan-carry-container-time",
          Label: "保存",
          Type: "primary",
          Size: "small",
        },
      ];
    } else {
      this.modalPlanCarryContainerTime.Title = "查看计划提柜时间";
    }
    this.modalPlanCarryContainerTime.HandleClick = this.handleTopButtonClick;
    this.formPlanCarryContainerTime.Items =
      DtoPutOrderPoolContainerTrailer_PlanCarryContainerTimeMiezzFormItems;
    this.formPlanCarryContainerTime.Rules =
      DtoPutOrderPoolContainerTrailer_PlanCarryContainerTimeRules;
  }

  /**实际提柜时间-模态框 */
  modalCarryContainerTime = new MiezzModal(MiezzModalType.Dialog);
  /**实际提柜时间-表单 */
  formCarryContainerTime = new MiezzForm<
    DtoPutOrderPoolContainerTrailer_CarryContainerTime,
    string
  >();
  /**实际提柜时间-初始化 */
  initCarryContainerTime(): void {
    this.modalCarryContainerTime.Height = "100px";
    if (this.editPower) {
      this.modalCarryContainerTime.Title = "编辑实际提柜时间";
      this.modalCarryContainerTime.Buttons = [
        {
          Code: "save-carry-container-time",
          Label: "保存",
          Type: "primary",
          Size: "small",
        },
      ];
    } else {
      this.modalCarryContainerTime.Title = "查看实际提柜时间";
    }
    this.modalCarryContainerTime.HandleClick = this.handleTopButtonClick;
    this.formCarryContainerTime.Items =
      DtoPutOrderPoolContainerTrailer_CarryContainerTimeMiezzFormItems;
    this.formCarryContainerTime.Rules =
      DtoPutOrderPoolContainerTrailer_CarryContainerTimeRules;
  }
  handleChangeCarryContainerTime(): void {
    const item = this.list.Data?.Items?.firstOrDefault(
      (it) => it.Id == this.id
    );
    if (
      item &&
      this.formCarryContainerTime.Data.CarryContainerTime &&
      item.ArrivalTime &&
      moment(this.formCarryContainerTime.Data.CarryContainerTime) >=
      moment(item.ArrivalTime)
    ) {
      if (this.serviceType == EnumOrderServiceType.DeparturePort) {
        ElMessage.warning(
          "时间应遵循如下规则：【实际提柜时间】早于【实际装柜时间】早于【进港时间】"
        );
      } else {
        ElMessage.warning(
          "时间应遵循如下规则：【实际提柜时间】早于【实际拆柜时间】早于【还柜时间】"
        );
      }
      this.formCarryContainerTime.Data.CarryContainerTime = undefined;
    }
    if (
      item &&
      this.formCarryContainerTime.Data.CarryContainerTime &&
      item.BackContainerTime &&
      moment(this.formCarryContainerTime.Data.CarryContainerTime) >=
      moment(item.BackContainerTime)
    ) {
      if (this.serviceType == EnumOrderServiceType.DeparturePort) {
        ElMessage.warning(
          "时间应遵循如下规则：【实际提柜时间】早于【实际装柜时间】早于【进港时间】"
        );
      } else {
        ElMessage.warning(
          "时间应遵循如下规则：【实际提柜时间】早于【实际拆柜时间】早于【还柜时间】"
        );
      }
      this.formCarryContainerTime.Data.CarryContainerTime = undefined;
    }
  }

  /**经停地址-抽屉 */
  modalStopAddress = new MiezzModal(MiezzModalType.Drawer);
  /**经停地址-表单 */
  formStopAddress = new MiezzForm<
    DtoPutOrderPoolContainerTrailer_StopAddress,
    string
  >();
  /**经停地址-添加按钮 */
  btnAddStopAddress: MiezzButton = {
    Code: "add-stop-address",
    Label: "添加",
    Icon: "plus",
    Type: "primary",
    Size: "small",
  };
  /**经停地址-删除按钮 */
  btnDeleteStopAddress: MiezzButton = {
    Code: "delete-stop-address",
    Title: "删除",
    Icon: "delete",
    Type: "text",
    Size: "small",
  };
  addresses: UiSelectOptionWithStringValue[] = [];
  /**经停地址-初始化 */
  initStopAddress(): void {
    if (this.canEdit) {
      this.modalStopAddress.Title = "编辑经停地址";
      this.modalStopAddress.Buttons = [
        {
          Code: "save-stop-address",
          Label: "保存",
          Type: "primary",
          Size: "small",
        },
      ];
    } else {
      this.modalStopAddress.Title = "查看经停地址";
    }
    this.modalStopAddress.HandleClick = this.handleTopButtonClick;
    this.formStopAddress.Items =
      DtoPutOrderPoolContainerTrailer_StopAddressMiezzFormItems;
    this.formStopAddress.Rules =
      DtoPutOrderPoolContainerTrailer_StopAddressRules;

    CompanyAddressAppService.GetAddressesByScene(
      "ContainerTrailerStopAddress"
    ).then((r) => {
      this.addresses = r.data.Data ?? [];
    });
  }

  getStopAddresses(q: string, cb: any): void {
    cb(
      q ? this.addresses.filter((it) => it.Label?.contains(q)) : this.addresses
    );
  }

  /**提货地址与时间-删除 */
  handleDeleteStopAddress(i: number, complete: () => void): void {
    this.formStopAddress.Data.StopAddresses?.splice(i, 1);
    complete();
  }

  /**进港码头-模态框 */
  modalIntoPortWharf = new MiezzModal(MiezzModalType.Dialog);
  /**进港码头-表单 */
  formIntoPortWharf = new MiezzForm<
    DtoPutOrderPoolContainerTrailer_IntoPortWharf,
    string
  >();
  /**进港码头-初始化 */
  initIntoPortWharf(): void {
    const label =
      this.serviceType == EnumOrderServiceType.DeparturePort
        ? "进港码头"
        : "还柜地点";
    this.modalIntoPortWharf.Height = "100px";
    if (this.canEdit) {
      this.modalIntoPortWharf.Title = "编辑" + label;
      this.modalIntoPortWharf.Buttons = [
        {
          Code: "save-into-port-wharf",
          Label: "保存",
          Type: "primary",
          Size: "small",
        },
      ];
    } else {
      this.modalIntoPortWharf.Title = "查看" + label;
    }
    this.modalIntoPortWharf.HandleClick = this.handleTopButtonClick;
    this.formIntoPortWharf.Items = [
      {
        Prop: "IntoPortWharfLabel",
        Label: label,
        Customize: true,
      },
    ];
    this.formIntoPortWharf.Rules =
      DtoPutOrderPoolContainerTrailer_IntoPortWharfRules;
  }

  /**进港时间/还柜时间-模态框 */
  modalBackContainerTime = new MiezzModal(MiezzModalType.Dialog);
  /**进港时间/还柜时间-表单 */
  formBackContainerTime = new MiezzForm<
    DtoPutOrderPoolContainerTrailer_BackContainerTime,
    string
  >();
  /**进港时间/还柜时间-初始化 */
  initBackContainerTime(): void {
    const label =
      this.serviceType == EnumOrderServiceType.DeparturePort
        ? "进港时间"
        : "还柜时间";
    this.modalBackContainerTime.Height = "100px";
    if (this.canEdit) {
      this.modalBackContainerTime.Title = "编辑" + label;
      this.modalBackContainerTime.Buttons = [
        {
          Code: "save-back-container-time",
          Label: "保存",
          Type: "primary",
          Size: "small",
        },
      ];
    } else {
      this.modalBackContainerTime.Title = "查看" + label;
    }
    this.modalBackContainerTime.HandleClick = this.handleTopButtonClick;
    this.formBackContainerTime.Items = [
      {
        Prop: "BackContainerTime",
        Label: label,
        Customize: true,
      },
    ];

    this.formBackContainerTime.Rules =
      DtoPutOrderPoolContainerTrailer_BackContainerTimeRules;
  }
  handleChangeBackContainerTime(): void {
    const item = this.list.Data?.Items?.firstOrDefault(
      (it) => it.Id == this.id
    );
    if (
      item &&
      this.formBackContainerTime.Data.BackContainerTime &&
      item.CarryContainerTime &&
      moment(this.formBackContainerTime.Data.BackContainerTime) <=
      moment(item.CarryContainerTime)
    ) {
      if (this.serviceType == EnumOrderServiceType.DeparturePort) {
        ElMessage.warning(
          "时间应遵循如下规则：【实际提柜时间】早于【实际装柜时间】早于【进港时间】"
        );
      } else {
        ElMessage.warning(
          "时间应遵循如下规则：【实际提柜时间】早于【实际拆柜时间】早于【还柜时间】"
        );
      }
      this.formBackContainerTime.Data.BackContainerTime = undefined;
    }
    if (
      item &&
      this.formBackContainerTime.Data.BackContainerTime &&
      item.ArrivalTime &&
      moment(this.formBackContainerTime.Data.BackContainerTime) <=
      moment(item.ArrivalTime)
    ) {
      if (this.serviceType == EnumOrderServiceType.DeparturePort) {
        ElMessage.warning(
          "时间应遵循如下规则：【实际提柜时间】早于【实际装柜时间】早于【进港时间】"
        );
      } else {
        ElMessage.warning(
          "时间应遵循如下规则：【实际提柜时间】早于【实际拆柜时间】早于【还柜时间】"
        );
      }
      this.formBackContainerTime.Data.BackContainerTime = undefined;
    }
  }

  /**箱号-模态框 */
  modalContainerNo = new MiezzModal(MiezzModalType.Dialog);
  /**箱号-表单 */
  formContainerNo = new MiezzForm<
    DtoPutOrderPoolContainerTrailer_ContainerNo,
    string
  >();
  /**箱号-初始化 */
  initContainerNo(): void {
    this.modalContainerNo.Height = "100px";
    if (this.canEdit) {
      this.modalContainerNo.Title = "编辑箱号";
      this.modalContainerNo.Buttons = [
        {
          Code: "save-container-no",
          Label: "保存",
          SourceLabel: "保存",
          Type: "primary",
          Size: "small",
        },
      ];
    } else {
      this.modalContainerNo.Title = "查看箱号";
    }
    this.modalContainerNo.HandleClick = this.handleTopButtonClick;
    this.formContainerNo.Items =
      DtoPutOrderPoolContainerTrailer_ContainerNoMiezzFormItems;
    this.formContainerNo.Rules = {
      ContainerNo: [
        {
          required: true,
          message: "信息不能为空",
          trigger: "blur",
        },
        {
          validator: (rule: any, value: string, callback: any) => {
            if (!value) {
              return callback(new Error("信息不能为空"));
            } else if (value.length > 256) {
              return callback(new Error("文本长度不能超过 256 个字符"));
            } else {
              const reg = /^[A-Z]{4}[0-9]{7}$/;
              if (reg.test(value)) {
                // 箱号正则表达式
                const dic: any = {};
                dic["A"] = 10;
                dic["B"] = 12;
                dic["C"] = 13;
                dic["D"] = 14;
                dic["E"] = 15;
                dic["F"] = 16;
                dic["G"] = 17;
                dic["H"] = 18;
                dic["I"] = 19;
                dic["J"] = 20;
                dic["K"] = 21;
                dic["L"] = 23;
                dic["M"] = 24;
                dic["N"] = 25;
                dic["O"] = 26;
                dic["P"] = 27;
                dic["Q"] = 28;
                dic["R"] = 29;
                dic["S"] = 30;
                dic["T"] = 31;
                dic["U"] = 32;
                dic["V"] = 34;
                dic["W"] = 35;
                dic["X"] = 36;
                dic["Y"] = 37;
                dic["Z"] = 38;
                dic["0"] = 0;
                dic["1"] = 1;
                dic["2"] = 2;
                dic["3"] = 3;
                dic["4"] = 4;
                dic["5"] = 5;
                dic["6"] = 6;
                dic["7"] = 7;
                dic["8"] = 8;
                dic["9"] = 9;
                var number = value;
                var sum = 0;
                for (var i = 0; i < 10; i++) {
                  var char = number[i];
                  var code = dic[char];
                  sum += code * Math.pow(2, i);
                }
                var result = sum % 11;
                var end = parseInt(number[10]);
                var valid = result == end || result - end == 10;
                if (!valid) {
                  return callback(new Error("请填写正确的箱号信息"));
                } else {
                  OrderPoolContainerTrailerAppService.CheckExistContainerNo({
                    OrderId: this.formContainerNo.Data.OrderId,
                    PoolId: this.formContainerNo.Data.PoolId,
                    Id: this.formContainerNo.Data.Id,
                    ContainerNo: this.formContainerNo.Data.ContainerNo,
                    ServiceType: this.serviceType,
                  }).then((r) => {
                    if (r.data.Data) {
                      return callback(new Error("信息重复，请重新填写"));
                    } else {
                      return callback();
                    }
                  });
                }
              } else {
                return callback(new Error("请填写正确的箱号信息"));
              }
            }
          },
          trigger: "blur",
        },
      ],
    };
  }

  /**封号-模态框 */
  modalSealNo = new MiezzModal(MiezzModalType.Dialog);
  /**封号-表单 */
  formSealNo = new MiezzForm<DtoPutOrderPoolContainerTrailer_SealNo, string>();
  /**封号-初始化 */
  initSealNo(): void {
    this.modalSealNo.Height = "100px";
    if (this.canEdit) {
      this.modalSealNo.Title = "编辑封号";
      this.modalSealNo.Buttons = [
        {
          Code: "save-seal-no",
          Label: "保存",
          Type: "primary",
          Size: "small",
        },
      ];
    } else {
      this.modalSealNo.Title = "查看封号";
    }
    this.modalSealNo.HandleClick = this.handleTopButtonClick;
    this.formSealNo.Items =
      DtoPutOrderPoolContainerTrailer_SealNoMiezzFormItems;
    this.formSealNo.Rules = DtoPutOrderPoolContainerTrailer_SealNoRules;
  }

  /**附件-模态框 */
  modalFile = new MiezzModal(MiezzModalType.Dialog);
  /**附件-表单 */
  formFile = new MiezzForm<DtoPutOrderPoolContainerTrailer_File, string>();
  /**附件-初始化 */
  initFile(): void {
    if (this.canEdit) {
      this.modalFile.Title = "编辑附件";
      this.modalFile.Buttons = [
        {
          Code: "save-file",
          Label: "保存",
          Type: "primary",
          Size: "small",
        },
      ];
    } else {
      this.modalFile.Title = "查看附件";
    }
    this.modalFile.HandleClick = this.handleTopButtonClick;
    this.formFile.LabelWidth = "200px"
    this.formFile.Items = DtoPutOrderPoolContainerTrailer_FileMiezzFormItems;
    this.formFile.Rules = DtoPutOrderPoolContainerTrailer_FileRules;
  }

  /**顶部按钮点击 */
  handleTopButtonClick(btn: MiezzButton, complete: () => void): void {
    if (this.id && btn.Code != "add") {
      const row = this.list.Data?.Items?.firstOrDefault(
        (it) => it.Id == this.id
      );
      if (row) {
        if (row.Order?.Lock || row.Pool?.Lock) {
          ElMessage.warning("订单已锁定");
          complete();
          return;
        }
        if (row.Pool?.Status == EnumOrderPoolStatus.Canceled) {
          ElMessage.warning("委托书已取消，无法修改");
          complete();
          return;
        }
        if (row.Order?.Status == EnumOrderStatus.Canceled) {
          ElMessage.warning("订单已取消，无法修改");
          complete();
          return;
        }
      }
    }
    switch (btn.Code) {
      case "export":
        var dto = JSON.copy(this.list.Dto);
        dto.PoolId = this.poolId;
        dto.OrderId = this.orderId;
        dto.ServiceType = this.serviceType;
        dto.PageSize = 9999999;
        OrderPoolContainerTrailerAppService.Export(dto)
          .then((r) => {
            window.open(process.env.VUE_APP_BASE_URL + r.data.Data, "_blank");
            complete();
          })
          .catch(complete);
        break;
      case "add":
        if (this.list.Data?.PoolId) {
          OrderPoolContainerTrailerAppService.PostByPoolIdByServiceType(
            this.list.Data?.PoolId, //需要修改
            this.serviceType
          )
            .then(() => {
              this.handleGet();
              ElMessage.success("添加成功");
              complete();
            })
            .catch(complete);
        } else if (!this.pageSize) {
          this.modalAdd.Show = true;
          this.formAdd.Data = {};
          complete();
        } else {
          complete();
        }
        break;
      case "save-add":
        (this.$refs["ref-form-add"] as any).validate((v: boolean) => {
          if (v) {
            OrderPoolContainerTrailerAppService.PostByPoolIdByServiceType(
              this.formAdd.Data.PoolId,
              this.serviceType
            )
              .then(() => {
                this.handleGet();
                this.modalAdd.Show = false;
                ElMessage.success("添加成功");
                complete();
              })
              .catch(complete);
          } else {
            setTimeout(() => {
              const error = document.getElementsByClassName("is-error");
              error[0]?.querySelector("input")?.focus();
            }, 1);
            complete();
          }
        });
        complete();
        break;
      case "save-container-type":
        MiezzForm.submit(this.$refs, "ref-form-container-type", (v) => {
          if (v) {
            OrderPoolContainerTrailerAppService.PutContainerType(
              this.formContainerType.Data
            )
              .then(() => {
                this.handleGet();
                this.modalContainerType.Show = false;
                ElMessage.success("编辑成功");
                complete();
              })
              .catch(complete);
          } else {
            complete();
          }
        });
        break;
      case "add-address":
        this.formAddresses.Data.Addresses?.push({
          CompanyAddress: {
            AreaLabel: this.formAddresses.Data.DeliveryPlaceLabel,
            Address: this.formAddresses.Data.DeliveryPlaceAddress,
          },
        });
        complete();
        break;
      case "add-stop-address":
        this.formStopAddress.Data.StopAddresses?.push({});
        complete();
        break;
      case "add-executor":
        this.formExecutor.Data.Executors?.push({});
        complete();
        break;
      case "save-carry-plan-time":
        MiezzForm.submit(this.$refs, "ref-form-carry-plan-time", async (v) => {
          if (v) {
            if (
              this.formCarryPlanTime.Data.Addresses &&
              this.formCarryPlanTime.Data.Addresses.length > 0
            ) {
              this.formCarryPlanTime.Data.Addresses[0].PlanTime =
                this.formCarryPlanTime.Data.CarryPlanTime;
            } else {
              this.formCarryPlanTime.Data.Addresses = [
                {
                  PlanTime: this.formCarryPlanTime.Data.CarryPlanTime,
                },
              ];
            }
            if (this.formCarryPlanTime.Data.Id) {
              OrderPoolContainerTrailerAppService.PutAddresses(
                this.formCarryPlanTime.Data
              )
                .then(() => {
                  this.handleGet();
                  this.modalCarryPlanTime.Show = false;
                  ElMessage.success("编辑成功");
                  complete();
                })
                .catch(complete);
            } else {
              for (const id of this.list.SelectIds) {
                await OrderPoolContainerTrailerAppService.PutAddresses(
                  {
                    ...this.formCarryPlanTime.Data,
                    Id: id
                  }
                )
              }
              this.handleGet();
              this.modalCarryPlanTime.Show = false;
              ElMessage.success("编辑成功");
              complete();
            }
          } else {
            complete();
          }
        });
        break;
      case "save-addresses":
        MiezzForm.submit(this.$refs, "ref-form-addresses", async (v) => {
          if (v) {
            if (this.formAddresses.Data.Id) {

              OrderPoolContainerTrailerAppService.PutAddresses(
                this.formAddresses.Data
              )
                .then(() => {
                  this.handleGet();
                  this.modalAddresses.Show = false;
                  ElMessage.success("编辑成功");
                  complete();
                })
                .catch(complete);
            } else {
              for (const id of this.list.SelectIds) {
                await OrderPoolContainerTrailerAppService.PutAddresses(
                  {
                    ...this.formAddresses.Data,
                    Id: id,
                  }
                )
              }
              this.handleGet();
              this.modalAddresses.Show = false;
              ElMessage.success("编辑成功");
              complete();
            }
          } else {
            complete();
          }
        });
        break;
      case "save-stop-address":
        MiezzForm.submit(this.$refs, "ref-form-stop-address", async (v) => {
          if (v) {
            if (this.formStopAddress.Data.Id) {
              OrderPoolContainerTrailerAppService.PutStopAddress(
                this.formStopAddress.Data
              )
                .then(() => {
                  this.handleGet();
                  this.modalStopAddress.Show = false;
                  ElMessage.success("编辑成功");
                  complete();
                })
                .catch(complete);
            } else {
              for (const id of this.list.SelectIds) {
                await OrderPoolContainerTrailerAppService.PutStopAddress(
                  {
                    ...this.formStopAddress.Data,
                    Id: id,
                  }
                )
              }
              this.handleGet();
              this.modalStopAddress.Show = false;
              ElMessage.success("编辑成功");
              complete();
            }
          } else {
            complete();
          }
        });
        break;
      case "save-arrival-time":
        MiezzForm.submit(this.$refs, "ref-form-arrival-time", async (v) => {
          if (v) {
            if (this.formArrivalTime.Data.Id) {
              OrderPoolContainerTrailerAppService.PutArrivalTime(
                this.formArrivalTime.Data
              )
                .then(() => {
                  this.handleGet();
                  this.modalArrivalTime.Show = false;
                  ElMessage.success("编辑成功");
                  complete();
                })
                .catch(complete);
            } else {
              for (const id of this.list.SelectIds) {
                await OrderPoolContainerTrailerAppService.PutArrivalTime(
                  {
                    ...this.formArrivalTime.Data,
                    Id: id,
                  }
                )
              }
              this.handleGet();
              this.modalArrivalTime.Show = false;
              ElMessage.success("编辑成功");
              complete();
            }

          } else {
            complete();
          }
        });
        break;
      case "save-executor":
        MiezzForm.submit(this.$refs, "ref-form-executor", (v) => {
          if (v) {
            OrderPoolContainerTrailerAppService.PutExecutor(
              this.formExecutor.Data
            )
              .then(() => {
                this.handleGet();
                this.modalExecutor.Show = false;
                ElMessage.success("编辑成功");
                complete();
              })
              .catch(complete);
          } else {
            complete();
          }
        });
        break;
      case "save-carry-container-area":
        MiezzForm.submit(this.$refs, "ref-form-carry-container-area", async (v) => {
          if (v) {
            const save = async () => {
              if (this.formCarryContainerArea.Data.Id) {
                OrderPoolContainerTrailerAppService.PutCarryContainerArea(
                  this.formCarryContainerArea.Data
                )
                  .then(() => {
                    this.handleGet();
                    this.modalCarryContainerArea.Show = false;
                    ElMessage.success("编辑成功");
                    complete();
                  })
                  .catch(complete);
              } else {
                for (const id of this.list.SelectIds) {
                  await OrderPoolContainerTrailerAppService.PutCarryContainerArea(
                    {
                      ...this.formCarryContainerArea.Data,
                      Id: id,
                    }
                  )
                }
                this.handleGet();
                this.modalCarryContainerArea.Show = false;
                ElMessage.success("编辑成功");
                complete();
              }
            }
            if (this.row?.Order?.UseThreeApiService) {
              ElMessageBox.confirm('此处为通过接口自动获取的信息，修改后将不再接收推送信息，是否继续', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning'
              }).then(async () => {
                await save();
              }).catch(complete)
            } else {
              await save();
            }
          } else {
            complete();
          }
        });
        break;
      case "save-plan-carry-container-time":
        MiezzForm.submit(
          this.$refs,
          "ref-form-plan-carry-container-time",
          async (v) => {
            if (v) {
              console.log(this.row?.BindThreeApiPropList, this.row && this.row.BindThreeApiPropList?.contains('PlanCarryContainerTime'))
              const save = async () => {
                if (this.formPlanCarryContainerTime.Data.Id) {
                  OrderPoolContainerTrailerAppService.PutPlanCarryContainerTime(
                    this.formPlanCarryContainerTime.Data
                  )
                    .then(() => {
                      this.handleGet();
                      this.modalPlanCarryContainerTime.Show = false;
                      ElMessage.success("编辑成功");
                      complete();
                    })
                    .catch(complete);
                } else {
                  for (const id of this.list.SelectIds) {
                    await OrderPoolContainerTrailerAppService.PutPlanCarryContainerTime(
                      {
                        ...this.formPlanCarryContainerTime.Data,
                        Id: id
                      }
                    )
                  }
                  this.handleGet();
                  this.modalPlanCarryContainerTime.Show = false;
                  ElMessage.success("编辑成功");
                  complete();
                }
              }
              if (this.row?.Order?.UseThreeApiService) {
                ElMessageBox.confirm('此处为通过接口自动获取的信息，修改后将不再接收推送信息，是否继续', '提示', {
                  confirmButtonText: '是',
                  cancelButtonText: '否',
                  type: 'warning'
                }).then(async () => {
                  await save();
                }).catch(complete)
              } else {
                await save();
              }
            } else {
              complete();
            }
          }
        );
        break;
      case "save-carry-container-time":
        MiezzForm.submit(this.$refs, "ref-form-carry-container-time", async (v) => {
          if (v) {
            const save = async () => {
              if (this.formCarryContainerTime.Data.Id) {
                OrderPoolContainerTrailerAppService.PutCarryContainerTime(
                  this.formCarryContainerTime.Data
                )
                  .then(() => {
                    this.handleGet();
                    this.modalCarryContainerTime.Show = false;
                    ElMessage.success("编辑成功");
                    complete();
                  })
                  .catch(complete);
              } else {
                for (const id of this.list.SelectIds) {
                  await OrderPoolContainerTrailerAppService.PutCarryContainerTime(
                    {
                      ...this.formCarryContainerTime.Data,
                      Id: id
                    }
                  )
                }
                this.handleGet();
                this.modalCarryContainerTime.Show = false;
                ElMessage.success("编辑成功");
                complete();
              }
            }
            if (this.row?.Order?.UseThreeApiService) {
              ElMessageBox.confirm('此处为通过接口自动获取的信息，修改后将不再接收推送信息，是否继续', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning'
              }).then(async () => {
                await save();
              }).catch(complete)
            } else {
              await save();
            }
          } else {
            complete();
          }
        });
        break;
      case "save-into-port-wharf":
        MiezzForm.submit(this.$refs, "ref-form-into-port-wharf", async (v) => {
          if (v) {
            const save = async () => {
              if (this.formIntoPortWharf.Data.Id) {
                OrderPoolContainerTrailerAppService.PutIntoPortWharf(
                  this.formIntoPortWharf.Data
                )
                  .then(() => {
                    this.handleGet();
                    this.modalIntoPortWharf.Show = false;
                    ElMessage.success("编辑成功");
                    complete();
                  })
                  .catch(complete);
              } else {
                for (const id of this.list.SelectIds) {
                  await OrderPoolContainerTrailerAppService.PutIntoPortWharf(
                    {
                      ...this.formIntoPortWharf.Data,
                      Id: id
                    }
                  )
                }
                this.handleGet();
                this.modalIntoPortWharf.Show = false;
                ElMessage.success("编辑成功");
                complete();
              }
            }
            if (this.row?.Order?.UseThreeApiService) {
              ElMessageBox.confirm('此处为通过接口自动获取的信息，修改后将不再接收推送信息，是否继续', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning'
              }).then(async () => {
                await save();
              }).catch(complete)
            } else {
              await save();
            }
          } else {
            complete();
          }
        });
        break;
      case "save-back-container-time":
        MiezzForm.submit(this.$refs, "ref-form-back-container-time", async (v) => {
          if (v) {
            const save = async () => {
              if (this.formBackContainerTime.Data.Id) {
                OrderPoolContainerTrailerAppService.PutBackContainerTime(
                  this.formBackContainerTime.Data
                )
                  .then(() => {
                    this.handleGet();
                    this.modalBackContainerTime.Show = false;
                    ElMessage.success("编辑成功");
                    complete();
                  })
                  .catch(complete);
              } else {
                for (const id of this.list.SelectIds) {
                  await OrderPoolContainerTrailerAppService.PutBackContainerTime(
                    {
                      ...this.formBackContainerTime.Data,
                      Id: id
                    }
                  )
                }
                this.handleGet();
                this.modalBackContainerTime.Show = false;
                ElMessage.success("编辑成功");
                complete();
              }
            }
            if (this.row?.Order?.UseThreeApiService) {
              ElMessageBox.confirm('此处为通过接口自动获取的信息，修改后将不再接收推送信息，是否继续', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning'
              }).then(async () => {
                await save();
              }).catch(complete)
            } else {
              await save();
            }
          } else {
            complete();
          }
        });
        break;
      case "save-container-no":
        btn.Countdown = moment().add(15, "s").toDate();
        MiezzForm.submit(this.$refs, "ref-form-container-no", async (v) => {
          if (v) {
            const save = async () => {
              OrderPoolContainerTrailerAppService.PutContainerNo(
                this.formContainerNo.Data
              )
                .then(() => {
                  if (this.formContainerNo.Data.OrderId) {
                    OrderMainBillAppService.AutoPullThreeApiData({
                      OrderId: this.formContainerNo.Data.OrderId,
                      UpdateData: true,
                      UpdateMainBill: true,
                    }).then((r) => {
                      if ((r.data.Data?.Errors?.length ?? 0) > 0) {
                        for (const error of r.data.Data?.Errors ?? []) {
                          ElMessage.warning(error);
                        }
                      } else {
                        const model =
                          r.data.Data?.ContainerTrailers?.firstOrDefault(
                            (it) => it.Id == this.formContainerNo.Data.Id
                          );
                        if (
                          model &&
                          (model.BindThreeApiPropList?.length ?? 0) > 0
                        ) {
                          ElMessage.success(
                            "已通过第三方为您获取到相应信息，此类信息（标题为绿色）的变化将由接口推送并禁止修改"
                          );
                        } else {
                          ElMessage.success(
                            "已向第三方接口发送请求，数据会有延迟，请稍后再来查看"
                          );
                        }

                        CurrentLogier.HubConnection?.off(
                          "RefreshContainerTrailer"
                        );
                        CurrentLogier.HubConnection?.on(
                          "RefreshContainerTrailer",
                          (id: string) => {
                            if (id == this.formContainerNo.Data.Id) {
                              this.handleGet();
                            }
                          }
                        );
                      }
                    });
                  }
                  this.handleGet();
                  this.modalContainerNo.Show = false;
                  ElMessage.success("编辑成功");
                  complete();
                })
                .catch(complete);
            }
            await save();
            // if (this.row?.Order?.UseThreeApiService) {
            //   ElMessageBox.confirm('此处为通过接口自动获取的信息，修改后将不再接收推送信息，是否继续', '提示', {
            //     confirmButtonText: '是',
            //     cancelButtonText: '否',
            //     type: 'warning'
            //   }).then(async () => {
            //     await save();
            //   }).catch(complete)
            // } else {
            //   await save();
            // }
          } else {
            complete();
          }
        });
        break;
      case "save-seal-no":
        MiezzForm.submit(this.$refs, "ref-form-seal-no", async (v) => {
          if (v) {
            const save = async () => {
              OrderPoolContainerTrailerAppService.PutSealNo(this.formSealNo.Data)
                .then(() => {
                  this.handleGet();
                  this.modalSealNo.Show = false;
                  ElMessage.success("编辑成功");
                  complete();
                })
                .catch(complete);
            }
            // if (this.row?.Order?.UseThreeApiService) {
            //   ElMessageBox.confirm('此处为通过接口自动获取的信息，修改后将不再接收推送信息，是否继续', '提示', {
            //     confirmButtonText: '是',
            //     cancelButtonText: '否',
            //     type: 'warning'
            //   }).then(async () => {
            //     await save();
            //   }).catch(complete)
            // } else {
            //   await save();
            // }
            await save();
          } else {
            complete();
          }
        });
        break;
      case "save-file":
        MiezzForm.submit(this.$refs, "ref-form-file", (v) => {
          if (v) {
            OrderPoolContainerTrailerAppService.PutFile(this.formFile.Data)
              .then(() => {
                this.handleGet();
                this.modalFile.Show = false;
                ElMessage.success("编辑成功");
                complete();
              })
              .catch(complete);
          } else {
            complete();
          }
        });
        break;
      default:
        break;
    }
  }

  /**行按钮点击 */
  handleRowButtonClick(
    btn: MiezzButton,
    row: DtoListItemOrderPoolContainerTrailer,
    complete: () => void
  ): void {
    switch (btn.Code) {
      case "mark":
        ListMarkColorAppService.Post({
          TableName: "OrderPoolContainerTrailer",
          TableIds: [row.Id ?? ""],
          Color: btn.Color,
        }).then(() => {
          this.handleGet();
          complete();
        });
        break;
      case "delete":
        if ((this.list.Data?.Items?.length ?? 0) == 1) {
          ElMessage.warning("至少需要保留一条信息");
          complete();
          return;
        }
        if (row.Pool?.Lock || row.Order?.Lock) {
          ElMessage.warning("订单已锁定");
          complete();
          return;
        }
        if (row.Pool?.Status == EnumOrderPoolStatus.Canceled) {
          ElMessage.warning("委托书已取消，无法修改");
          complete();
          return;
        }
        if (row.Order?.Status == EnumOrderStatus.Canceled) {
          ElMessage.warning("订单已取消，无法修改");
          complete();
          return;
        }
        OrderPoolContainerTrailerAppService.Delete([row.Id ?? ""]).then(() => {
          ElMessage.success("删除成功");
          this.handleGet();
          complete();
        });
        break;

      default:
        break;
    }
  }

  handleTitleClick(btn: MiezzButton, complete: () => void, prop: string): void {
    if (btn.Code == "mark") {
      ListMarkColorAppService.Post({
        TableName: "OrderPoolContainerTrailer",
        TableIds: this.list.SelectIds,
        Color: btn.Color,
      }).then(() => {
        this.handleGet();
        complete();
      });
    } else if (btn.Code == "export") {
        var dto = JSON.copy(this.list.Dto);
        dto.PoolId = this.poolId;
        dto.OrderId = this.orderId;
        dto.ServiceType = this.serviceType;
        dto.PageSize = 9999999;
        dto.Ids = this.list.SelectIds;
        OrderPoolContainerTrailerAppService.Export(dto)
          .then((r) => {
            window.open(process.env.VUE_APP_BASE_URL + r.data.Data, "_blank");
            complete();
          })
          .catch(complete);
    } else {
      this.id = undefined;
      if (this.pageSize == 9999999) {
        this.list.SelectIds = this.list.Data?.Items?.map(it => it.Id!) ?? [];
        this.list.SelectRows = this.list.Data?.Items ?? [];
      }
      if (this.list.SelectRows.map(it => it.ClientCompany).distinct().length > 1) {
        ElMessage.warning("不同委托人的信息不能批量处理，请重新选择");
        complete();
        return;
      }
      prop = prop ?? btn.Code;
      switch (prop) {
        case "CarryPlanTime":
          this.formCarryPlanTime.Data =
            new DtoPutOrderPoolContainerTrailer_Addresses();
          this.formCarryPlanTime.Data.Id = undefined;
          this.modalCarryPlanTime.Show = true;
          break;
        case "Addresses":
          this.formAddresses.Data =
            new DtoPutOrderPoolContainerTrailer_Addresses();
          this.formAddresses.Data.Id = undefined;
          this.modalAddresses.Show = true;
          break;
        case "ArrivalTime":
          this.formArrivalTime.Data =
            new DtoPutOrderPoolContainerTrailer_ArrivalTime();
          this.formArrivalTime.Data.Id = undefined;
          this.modalArrivalTime.Show = true;
          break;
        case "SupplierLabel":
          (this.$refs["ref-order-supplier"] as OrderSupplier).handleShow({});
          break;
        case "CarryContainerAreaLabel":
          this.formCarryContainerArea.Data =
            new DtoPutOrderPoolContainerTrailer_CarryContainerArea();
          this.formCarryContainerArea.Data.Id = undefined;
          this.modalCarryContainerArea.Show = true;
          break;
        case "PlanCarryContainerTime":
          this.formPlanCarryContainerTime.Data =
            new DtoPutOrderPoolContainerTrailer_PlanCarryContainerTime();
          this.formPlanCarryContainerTime.Data.Id = undefined;
          this.modalPlanCarryContainerTime.Show = true;
          break;
        case "CarryContainerTime":
          this.formCarryContainerTime.Data =
            new DtoPutOrderPoolContainerTrailer_CarryContainerTime();
          this.formCarryContainerTime.Data.Id = undefined;
          this.modalCarryContainerTime.Show = true;
          break;
        case "StopAddress":
          this.formStopAddress.Data =
            new DtoPutOrderPoolContainerTrailer_StopAddress();
          this.formStopAddress.Data.Id = undefined;
          this.modalStopAddress.Show = true;
          break;
        case "IntoPortWharfLabel":
          this.formIntoPortWharf.Data =
            new DtoPutOrderPoolContainerTrailer_IntoPortWharf();
          this.formIntoPortWharf.Data.Id = undefined;
          this.modalIntoPortWharf.Show = true;
          break;
        case "BackContainerTime":
          this.formBackContainerTime.Data =
            new DtoPutOrderPoolContainerTrailer_BackContainerTime();
          this.formBackContainerTime.Data.Id = undefined;
          this.modalBackContainerTime.Show = true;
          break;
        default:
          break;
      }
      complete();
    }
  }

  row?: DtoListItemOrderPoolContainerTrailer
  /**行按钮点击 */
  handleRowCommand(
    prop: string,
    row: DtoListItemOrderPoolContainerTrailer
  ): void {
    this.id = row.Id;
    this.row = row;
    switch (prop) {
      case "OrderCode":
        DynamicSearchAppService.Post({
          Code: "OrderManagement_Order",
          Brackets: [
            {
              Relation: EnumRelation.And,
              Items: [
                {
                  Relation: EnumRelation.And,
                  Where: {
                    Prop: "DynamicSearch_Code",
                    Compare: EnumCompare.Equal,
                    Value: row.OrderCode,
                  },
                },
              ],
            },
          ],
        }).then((r) => {
          if (row.OrderCode) {
            setTimeout(() => {
              window.open(
                `#/order?DynamicSearchId=${r.data.Data}&OpenSearch=true`,
                "_blank"
              );
            }, 500);
          }
        });
        break;
      case "CarryPlanTime":
        var addresses =
          (row.Addresses?.length ?? 0) > 0
            ? (JSON.copy(
              row.Addresses
            ) as DtoListItemOrderPoolContainerTrailer_OrderPoolContainerTrailerAddress[])
            : [{ CompanyAddress: {} }];
        this.formCarryPlanTime.Data =
          new DtoPutOrderPoolContainerTrailer_Addresses();
        this.formCarryPlanTime.Data.Id = this.id;
        if (this.serviceType == EnumOrderServiceType.DestinationPort) {
          const supplier = this.list.Data?.WharfSuppliers?.firstOrDefault(
            (it: any) => it.Id == (row?.PoolId ?? row.OrderId)
          );
          if (supplier) {
            this.formCarryPlanTime.Data.DeliveryPlaceLabel =
              this.formCarryPlanTime.Data.DeliveryPlaceLabel ??
              (supplier.NameZh ?? "") +
              (supplier.NameZh && supplier.NameEn ? "/" : "") +
              (supplier.NameEn ?? "");
            this.formCarryPlanTime.Data.DeliveryPlaceAddress =
              this.formCarryPlanTime.Data.DeliveryPlaceAddress ??
              (supplier.ReceivingAddressZh ?? "") +
              (supplier.ReceivingAddressZh && supplier.ReceivingAddressEn
                ? "/"
                : "") +
              (supplier.ReceivingAddressEn ?? "");
          } else {
            this.formCarryPlanTime.Data.DeliveryPlaceAddress =
              "暂未获知，待后续补充";
          }
          for (const address of addresses) {
            if (!address.CompanyAddress) {
              address.CompanyAddress = {};
            }
            if (!address.CompanyAddress.Address) {
              address.CompanyAddress.CompanyName =
                this.formCarryPlanTime.Data.DeliveryPlaceLabel;
              address.CompanyAddress.Address =
                this.formCarryPlanTime.Data.DeliveryPlaceAddress;
            }
          }
        }
        this.formCarryPlanTime.Data.Addresses = addresses;
        this.formCarryPlanTime.Data.CarryPlanTime =
          this.formCarryPlanTime.Data.Addresses.firstOrDefault()?.PlanTime;
        this.modalCarryPlanTime.Show = true;
        break;
      case "ContainerTypeLabel":
        this.formContainerType.Data =
          new DtoPutOrderPoolContainerTrailer_ContainerType();
        this.formContainerType.Data.Id = this.id;
        this.formContainerType.Data.ContainerTypeId = row.ContainerTypeId;
        this.formContainerType.Data.ContainerTypeLabel = row.ContainerTypeLabel;
        this.modalContainerType.Show = true;
        break;
      case "Addresses":
        var addresses2 =
          (row.Addresses?.length ?? 0) > 0
            ? (JSON.copy(
              row.Addresses
            ) as DtoListItemOrderPoolContainerTrailer_OrderPoolContainerTrailerAddress[])
            : [{ CompanyAddress: {} }];
        this.formAddresses.Data =
          new DtoPutOrderPoolContainerTrailer_Addresses();
        this.formAddresses.Data.Id = this.id;
        if (this.serviceType == EnumOrderServiceType.DestinationPort) {
          const supplier = this.list.Data?.WharfSuppliers?.firstOrDefault(
            (it: any) => it.Id == (row?.PoolId ?? row.OrderId)
          );
          if (supplier) {
            this.formAddresses.Data.DeliveryPlaceLabel =
              this.formAddresses.Data.DeliveryPlaceLabel ??
              (supplier.NameZh ?? "") +
              (supplier.NameZh && supplier.NameEn ? "/" : "") +
              (supplier.NameEn ?? "");
            this.formAddresses.Data.DeliveryPlaceAddress =
              this.formAddresses.Data.DeliveryPlaceAddress ??
              (supplier.ReceivingAddressZh ?? "") +
              (supplier.ReceivingAddressZh && supplier.ReceivingAddressEn
                ? "/"
                : "") +
              (supplier.ReceivingAddressEn ?? "");
          } else {
            this.formAddresses.Data.DeliveryPlaceAddress =
              "暂未获知，待后续补充";
          }
          for (const address of addresses2) {
            if (!address.CompanyAddress) {
              address.CompanyAddress = {};
            }
            if (!address.CompanyAddress.Address) {
              address.CompanyAddress.CompanyName =
                this.formAddresses.Data.DeliveryPlaceLabel;
              address.CompanyAddress.Address =
                this.formAddresses.Data.DeliveryPlaceAddress;
            }
          }
        }
        this.formAddresses.Data.Addresses = addresses2;
        this.modalAddresses.Show = true;
        break;
      case "ArrivalTime":
        this.formArrivalTime.Data =
          new DtoPutOrderPoolContainerTrailer_ArrivalTime();
        this.formArrivalTime.Data.Id = this.id;
        this.formArrivalTime.Data.ArrivalTime = row.ArrivalTime;
        this.formArrivalTime.Data.LeaveTime = row.LeaveTime;
        this.modalArrivalTime.Show = true;
        break;
      case "SupplierLabel":
        (this.$refs["ref-order-supplier"] as OrderSupplier).handleShow(row);
        break;
      case "ExecutorLabel":
        this.formExecutor.Data = new DtoPutOrderPoolContainerTrailer_Executor();
        this.formExecutor.Data.Id = this.id;
        this.formExecutor.Data.Executors = row.Executors;
        this.modalExecutor.Show = true;
        break;
      case "CarryContainerAreaLabel":
        this.formCarryContainerArea.Data =
          new DtoPutOrderPoolContainerTrailer_CarryContainerArea();
        this.formCarryContainerArea.Data.Id = this.id;
        this.formCarryContainerArea.Data.CarryContainerAreaId =
          row.CarryContainerAreaId;
        this.formCarryContainerArea.Data.CarryContainerAreaLabel =
          row.CarryContainerAreaLabel;
        this.modalCarryContainerArea.Show = true;
        break;
      case "PlanCarryContainerTime":
        this.formPlanCarryContainerTime.Data =
          new DtoPutOrderPoolContainerTrailer_PlanCarryContainerTime();
        this.formPlanCarryContainerTime.Data.Id = this.id;
        this.formPlanCarryContainerTime.Data.PlanCarryContainerTime =
          row.PlanCarryContainerTime;
        this.modalPlanCarryContainerTime.Show = true;
        break;
      case "CarryContainerTime":
        this.formCarryContainerTime.Data =
          new DtoPutOrderPoolContainerTrailer_CarryContainerTime();
        this.formCarryContainerTime.Data.Id = this.id;
        this.formCarryContainerTime.Data.CarryContainerTime =
          row.CarryContainerTime;
        if (
          this.serviceType == EnumOrderServiceType.DestinationPort &&
          !this.formCarryContainerTime.Data.CarryContainerTime
        ) {
          OrderAppService.GetCarryContainerTime(row.OrderId, row.PoolId).then(
            (r) => {
              this.formCarryContainerTime.Data.CarryContainerTime = r.data.Data;
            }
          );
        }
        this.modalCarryContainerTime.Show = true;
        break;
      case "StopAddress":
        this.formStopAddress.Data =
          new DtoPutOrderPoolContainerTrailer_StopAddress();
        this.formStopAddress.Data.Id = this.id;
        this.formStopAddress.Data.StopAddress = row?.StopAddress;
        this.formStopAddress.Data.StopAddressCarBoardNumber =
          row?.StopAddressCarBoardNumber;
        this.formStopAddress.Data.StopAddresses =
          (row.StopAddresses?.length ?? 0) > 0
            ? JSON.copy(row?.StopAddresses ?? {})
            : [{}];
        this.modalStopAddress.Show = true;
        break;
      case "IntoPortWharfLabel":
        this.formIntoPortWharf.Data =
          new DtoPutOrderPoolContainerTrailer_IntoPortWharf();
        this.formIntoPortWharf.Data.Id = this.id;
        this.formIntoPortWharf.Data.IntoPortWharfId = row.IntoPortWharfId;
        this.formIntoPortWharf.Data.IntoPortWharfLabel = row.IntoPortWharfLabel;
        this.modalIntoPortWharf.Show = true;
        break;
      case "BackContainerTime":
        this.formBackContainerTime.Data =
          new DtoPutOrderPoolContainerTrailer_BackContainerTime();
        this.formBackContainerTime.Data.Id = this.id;
        this.formBackContainerTime.Data.BackContainerTime =
          row.BackContainerTime;
        this.modalBackContainerTime.Show = true;
        break;
      case "ContainerNo":
        this.formContainerNo.Data =
          new DtoPutOrderPoolContainerTrailer_ContainerNo();
        this.formContainerNo.Data.Id = this.id;
        this.formContainerNo.Data.PoolId = row.PoolId;
        this.formContainerNo.Data.OrderId = row.OrderId;
        this.formContainerNo.Data.ContainerNo = row.ContainerNo;
        this.formContainerNo.Data.Tare = row.Tare;
        this.formContainerNo.Data.TareDisabled =
          row.BindThreeApiPropList?.contains("Tare");
        this.modalContainerNo.Buttons?.forEach(
          (it) => (it.CountdownGroupBy = this.id)
        );
        this.modalContainerNo.Show = true;
        break;
      case "SealNo":
        this.formSealNo.Data = new DtoPutOrderPoolContainerTrailer_SealNo();
        this.formSealNo.Data.Id = this.id;
        this.formSealNo.Data.SealNo = row.SealNo;
        this.modalSealNo.Show = true;
        break;
      case "Files":
        this.formFile.Data = new DtoPutOrderPoolContainerTrailer_File();
        this.formFile.Data.Id = this.id;
        this.formFile.Data.ContainerNoFile = row.ContainerNoFile;
        this.formFile.Data.SealNoFile = row.SealNoFile;
        this.formFile.Data.Files = JSON.copy(row.Files ?? []);
        this.modalFile.Show = true;
        break;
      case "Process":
        ElMessage.warning("暂无数据，请向供应商询问详细进程");
        break;
      default:
        break;
    }
  }
}
